import { Store } from "../../types/contexts/enrollmentContext/store.types";

const initialState: Store = {
	currentEnrollment: null
};

export default initialState;
